import { createFileRoute, useParams } from "@tanstack/react-router";

import {
  SectionFormWrapper,
  AttributeRenderer,
  RenderContentProps,
} from "../../../../-shared";
import {
  useGetSpecialtyCertificationDetail,
  useUpdateSpecialtyCertificationDetail,
} from "../../../../-shared/-query";

export const Route = createFileRoute(
  "/_staff/certification/specialty-certification/$id/_layout/_index/",
)({
  component: SpecialtyCertificationDetail,
});

function SpecialtyCertificationDetail() {
  const { id } = useParams({
    from: "/_staff/certification/specialty-certification/$id/_layout/_index/",
  });

  return (
    <SectionFormWrapper
      useGetDetailQuery={useGetSpecialtyCertificationDetail(id)}
      useSaveMutation={useUpdateSpecialtyCertificationDetail(id)}
      renderContent={({ section }: RenderContentProps) => (
        <AttributeRenderer
          attributes={section.attributes}
          sectionKey={String(section.sectionKey)}
        />
      )}
    />
  );
}
